import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import USER_ROLE from 'constants/role';
import { AUTH_API } from 'middleware/api';
import getAny from 'utils/accessors/getAny.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import determineFirstNonNil from 'utils/determineFirstNonNil';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import { isNotValidId } from 'utils/predicates/fields.util';

import {
  ADD_STYLIST_FAILURE,
  ADD_STYLIST_REQUEST,
  ADD_STYLIST_SUCCESS,
  setStylistSaved,
} from 'onboarding/stylists/actions';

const ATAG = 'addStylist';
const L = logger(ATAG);

const EVERY_EMPTY_SPACE = / /g;

const determinePermissionLevel = (stylist) =>
  stylist.email
    ? fromAnyToString(stylist.permission_level).trim().toLowerCase() || USER_ROLE.manager
    : USER_ROLE.noAccess;

const postStylist = (options) => {
  const salonId = getAny(null, 'salonId', options);
  const stylist = getAny({}, 'stylist', options) || {};
  const name = getAny(undefined, 'user_name', stylist);
  const hasColumn = getAny(false, 'has_column', stylist);

  const data = {
    ...stylist,
    salon_id: salonId,
    role_id: hasColumn ? getAny(null, 'role.id', stylist) : undefined,
    role: hasColumn ? stylist.role : undefined,
    phone: getAny('', 'phone', stylist).replace(EVERY_EMPTY_SPACE, ''),
    permission_level: determinePermissionLevel(stylist),
    user_id: determineFirstNonNil(getAny(null, 'userId', options), getAny(null, 'user_id', stylist)) || null,
  };

  L.debug('postStylist()', options, data);

  return {
    ATAG,
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/stylist/`,
      authenticated: true,
      types: [ADD_STYLIST_REQUEST, ADD_STYLIST_SUCCESS, ADD_STYLIST_FAILURE],
      config: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
      params: { salonId },
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: { event: 'postStylist', properties: { name } },
      },
    },
  };
};

const addStylist = L.wrap('()', (options) => (dispatch) => {
  const dispatchPromise = dispatch(postStylist(options));

  dispatchPromise.then((result) => {
    const { response, type } = asObject(result);
    const stylistId = asObject(response).id;

    if (isNotValidId(stylistId)) {
      L.warn('()', 'Invalid stylistId:', stylistId);
    }

    if (type === ADD_STYLIST_SUCCESS && stylistId) {
      L.unignore('()', dispatch(setStylistSaved()));
    }
  });

  return dispatchPromise;
});

// noinspection JSUnusedGlobalSymbols
export default addStylist;
